package com.wintermar.inspection.feature.domain.usecase.auth

import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.feature.domain.model.auth.UserModel

interface GetUserUseCase {
    operator fun invoke(): Result<UserModel>
}

class GetUserUseCaseImpl(
    private val appSetting: AppSetting
) : GetUserUseCase {

    override operator fun invoke(): Result<UserModel> {
        return try {
            Result.Success(
                UserModel(
                    userId = appSetting.userId ?: "",
                    fullName = appSetting.userFullName ?: ""
                )
            )
        } catch (e: Exception) {
            Result.Error(error = e)
        }
    }
}
